var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBar'),_c('v-main',[_c('router-view')],1),_c('Footer'),_c('loading-overlay',{attrs:{"active":_vm.isLoading,"loader":"dots"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }